import clsx from 'clsx';
import styles from 'components/UI/V3/Table/Row/TableRow.module.scss';
import React from 'react';

type TableRowProps = React.ComponentProps<'tr'>;

export const TableRow: React.FC<TableRowProps> = ({ children, className, ...props }) => {
    return (
        <tr
            className={clsx(styles.root, className)}
            {...props}
        >
            {children}
        </tr>
    );
};
